module.exports = __webpack_public_path__ + "img/elementlengths_jasa.8a9f9ecc.png";